/**
 * Audit + API-request log viewer — admin only.
 *
 * Hits /api/admin/audit-log + /api/admin/api-request-log. Both are
 * gated server-side on the `users.manage` capability.
 */
import { apiFetch } from "./apiClient";

export interface AuditLogRow {
  audit_id: number;
  occurred_utc: string | null;
  actor_kind: string;
  actor_id: number | null;
  actor_name: string | null;
  action: string;
  target_kind: string | null;
  target_id: string | null;
  payload_json: string | null;
  ip: string | null;
}

export interface AuditLogPage {
  total: number;
  limit: number;
  offset: number;
  rows: AuditLogRow[];
}

export interface ApiRequestLogRow {
  request_id: number;
  occurred_utc: string | null;
  method: string;
  path: string;
  status: number;
  latency_ms: number | null;
  actor_kind: string;
  actor_id: number | null;
  actor_name: string | null;
  ip: string | null;
  user_agent: string | null;
}

export interface ApiRequestLogPage {
  total: number;
  limit: number;
  offset: number;
  rows: ApiRequestLogRow[];
}

export interface AuditFilters {
  since?: string;
  until?: string;
  actor_kind?: string;
  actor_id?: number;
  action?: string;
  target_kind?: string;
  limit?: number;
  offset?: number;
}

export interface ApiRequestFilters {
  since?: string;
  until?: string;
  actor_kind?: string;
  actor_id?: number;
  path?: string;
  min_status?: number;
  max_status?: number;
  limit?: number;
  offset?: number;
}

async function get<T>(token: string, path: string): Promise<T> {
  return apiFetch<T>(path, token);
}

function qs(params: object): string {
  const p = new URLSearchParams();
  for (const [k, v] of Object.entries(params as Record<string, unknown>)) {
    if (v === undefined || v === null || v === "") continue;
    p.set(k, String(v));
  }
  const s = p.toString();
  return s ? `?${s}` : "";
}

export function fetchAuditLog(
  token: string,
  filters: AuditFilters = {},
): Promise<AuditLogPage> {
  return get<AuditLogPage>(token, `/api/admin/audit-log${qs(filters)}`);
}

export function fetchApiRequestLog(
  token: string,
  filters: ApiRequestFilters = {},
): Promise<ApiRequestLogPage> {
  return get<ApiRequestLogPage>(token, `/api/admin/api-request-log${qs(filters)}`);
}
